import { render, staticRenderFns } from "./dashboard-projects.vue?vue&type=template&id=b193b77c&"
import script from "./dashboard-projects.vue?vue&type=script&lang=ts&"
export * from "./dashboard-projects.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-projects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports